var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"l-ss-c-filter-label"},[_c('span',[_vm._v(_vm._s(_vm.label))]),(_vm.showArrow)?_c('i',{domProps:{"innerHTML":_vm._s(_vm.iconArrowTop)}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }